import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { ScoInvestorProfile } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
export const ScoInvestorProfileSEO = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const seoProps = {};
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
ScoInvestorProfileSEO.fragments = {
  ScoInvestorProfile: () => gql`
    fragment _ on ScoInvestorProfile {
      id
    }
  `
};